import { useState, useEffect, useCallback, useContext } from 'react';
import AppsBannerLanding from 'components/AppsBannerLanding';
import i18n from 'utils/i18n';
import { routesPath } from 'utils/constants/routePath';
import { Container } from 'containers/Layout';
import { ThemeContext } from 'theme';
import fetchApi from 'hooks/fetchApi';
import API_NAME from 'services/api';
import TopGroups from 'containers/TopGroups';
import TopEvents from 'containers/TopGroups/TopEvents';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

const PAGINATION_PAGE_SIZE = 10;

const Groups: React.FC = () => {
  const router: any = useRouter();
  const { locale } = router;
  const followingData = useSelector((store) => store.fetchData);
  const [selectedBrands, setSelectedBrands] = useState(
    router?.query?.brands?.split(',') || []
  );
  const { action, loading } = fetchApi();
  const context: any = useContext(ThemeContext);

  const getDataToPagination = useCallback(
    async (selected = 0, selectedBrands, location = {}) => {
      try {
        await action(API_NAME.LANDING_GET_GROUPS, {
          params: {
            start: (selected || router?.query?.page) * PAGINATION_PAGE_SIZE,
            limit: PAGINATION_PAGE_SIZE,
            filter: selectedBrands?.toString() || router?.query?.brands,
            range: location?.range || router?.query?.range || 0,
            lng: location?.lng || router?.query?.lng || '',
            lat: location?.lat || router?.query?.lat || '',
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    []
  );

  const getTopEvents = useCallback(async () => {
    try {
      await action(API_NAME?.LANDING_GET_EVENTS, {
        params: {
          start: 0,
          limit: 6,
        },
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchBrands = useCallback(() => {
    action(API_NAME.CAR_GET_CAR_BRANDS, {});
  }, []);

  useEffect(() => {
    if (!(followingData[API_NAME.LANDING_GET_GROUPS]?.data?.result?.length > 0))
      getDataToPagination(0, '', '');
  }, []);

  useEffect(() => {
    if (!(followingData[API_NAME.LANDING_GET_EVENTS]?.data?.result?.length > 0))
      getTopEvents();
  }, []);

  useEffect(() => {
    if (!(followingData[API_NAME.CAR_GET_CAR_BRANDS]?.data?.length > 0))
      fetchBrands();
  }, []);

  return (
    <Container
      meta={{
        title: i18n.t('landing:groups:groupTopTitle', {
          location: '',
          lng: locale,
        }),
        ogTitle: i18n.t('landing:groups:groupTopTitle', {
          location: '',
          lng: locale,
        }),
        ogUrl:
          locale === 'es'
            ? routesPath.es_landing_groups
            : routesPath.es_landing_groups,
        description: i18n.t('landing:groups:groupTopText', {
          location: '',
          lng: locale,
        }),
        ogImage: context?.content?.landingGroupBanner,
        isResize: false,
      }}
    >
      <TopGroups
        data={followingData[API_NAME.LANDING_GET_GROUPS]?.data?.result}
        brands={followingData[API_NAME.CAR_GET_CAR_BRANDS]?.data}
        onPagination={getDataToPagination}
        total={followingData[API_NAME.LANDING_GET_GROUPS]?.data?.total || 0}
        loading={loading[API_NAME.LANDING_GET_GROUPS]}
        setSelectedBrands={setSelectedBrands}
        selectedBrands={selectedBrands}
        isAuthenticate={context?.isAuthenticate}
      />
      <TopEvents
        events={followingData[API_NAME.LANDING_GET_EVENTS]?.data?.result}
        loading={loading[API_NAME.LANDING_GET_EVENTS]}
      />
      <AppsBannerLanding />
    </Container>
  );
};

export default Groups;
